exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table {\n  table-layout: fixed;\n  border-collapse: collapse; }\n  .table .tr-head {\n    background: #1464f6;\n    color: white; }\n  .table .lines {\n    border-collapse: collapse;\n    border: 1px dotted gray; }\n  .table th,\n  .table td {\n    padding: 2px 5px;\n    border: #28a745 1px solid;\n    min-width: 15vh;\n    /*-webkit-transform: rotate(90deg);\r\n    -moz-transform: rotate(90deg);*/ }\n    .table th .select-table,\n    .table td .select-table {\n      margin-top: 5px;\n      width: 80%; }\n  .table thead,\n  .table tbody {\n    border: #28a745 1px solid; }\n  .table td.center {\n    text-align: center;\n    min-width: 100px; }\n  .table tr.height {\n    height: 30px; }\n\n.container-table {\n  max-height: 40vh;\n  max-width: 99%;\n  overflow: auto; }\n\n.min-height {\n  min-height: 400px; }\n\n.flo-r {\n  float: right; }\n\nag-grid-angular.container-file {\n  max-height: 40vh;\n  height: 40vh;\n  max-width: 99%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/import-template/import-template.component.scss
// module id = 2035
// module chunks = 66